import script from "./InvestimentosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestimentosPage.vue?vue&type=script&setup=true&lang=js"

import "./InvestimentosPage.vue?vue&type=style&index=0&id=3c825cac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c825cac"]])

export default __exports__